import { render, staticRenderFns } from "./Def.vue?vue&type=template&id=3c195019&scoped=true&"
import script from "./Def.vue?vue&type=script&lang=js&"
export * from "./Def.vue?vue&type=script&lang=js&"
import style0 from "./Def.vue?vue&type=style&index=0&id=3c195019&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c195019",
  null
  
)

export default component.exports